import { isEmpty } from 'util/index';

/**
 * Check if the vendor object is attached to the window
 * @param {string} vendor //the vendor namespace
 * @returns {Promise}
 */

export default function onVendorLoaded(vendor: string): Promise<unknown> {
  return new Promise<void>((resolve, reject) => {
    const retryLimit = 20;
    let retry = 0;
    const interval = setInterval(() => {
      if (!isEmpty(window[vendor])) {
        clearInterval(interval);
        resolve();
        return;
      }
      if (retry >= retryLimit) {
        clearInterval(interval);
        reject(new Error(`window.${vendor} is undefined`));
        return;
      }
      retry++;
    }, 500);
  });
}
